export enum AudienceSourceEnum {
  NEW_TARGETING = 'New Targeting',
  SIMILAR_STORIES = 'Similar Stories'
}
